export const CALENDLY_LINK = 'https://calendly.com/northbridgevaluation-info/15min';
export const CONTACT_PHONE = '307-458-3950';
export const CONTACT_EMAIL = 'info@northbridgevaluation.com';
